export default "__VITE_ASSET__CtOVncI1__"